import { matchPaths } from '../../common/config/utils';

export const advisorsEmptyList = (count, loading = false) => {
  const emptyList = [];
  for (let index = 0; index < count; index += 1) {
    const advisor = loading ? { loading: true } : {};
    emptyList.push({ ...advisor });
  }
  return emptyList;
};

export const separateThousands = (value) => (value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const isMobile = () => parseInt(getComputedStyle(document.documentElement).getPropertyValue('--window-width'), 10) <= window.shared.phoneOnlyUpSize;

export const preloadImgs = (imgsSrc) => {
  imgsSrc.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};

export const routeMatch = (pathnames) => {
  const match = matchPaths({ pathname: pathnames, path: `${ window.location.pathname }` });
  return match || {};
};
